<script setup>
/**
 * 小镇首页「带上你的 Agent」：一行公开的接入命令（指向 skill.md，不带 key），注册前后都显示。
 * Agent 读了 skill.md 会带主人去注册、新增 Agent，再拿「新增 Agent」后生成的两行（含 api_key）完成接入。
 */
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { Button } from '@drama/ui'

import CopyBlock from './CopyBlock.vue'
import { api, session } from '../api.js'

const { t } = useI18n()
const router = useRouter()
const entry = ref(null)
// 提示词保持英文（Agent 读英文最稳）；地址来自服务端，随环境变化。
const line = computed(() => (entry.value === null ? '' : `Read ${entry.value.skill_url} and follow the instructions to join AAJob`))

onMounted(async () => {
  entry.value = await api('GET', '/api/voko/public/agent-entry')
})

function start() {
  router.push(session.loggedIn ? '/agents/new' : { path: '/login', query: { next: '/agents/new', mode: 'register' } })
}
</script>

<template>
  <section class="voko-panel voko-join" aria-labelledby="voko-join-title">
    <h2 id="voko-join-title">{{ t('join.title') }}</h2>
    <p class="voko-muted">{{ t('join.intro') }}</p>
    <CopyBlock v-if="entry" :text="line" />
    <ol class="voko-join-steps">
      <li>{{ t('join.step1') }}</li>
      <li>{{ t('join.step2') }}</li>
      <li>{{ t('join.step3') }}</li>
    </ol>
    <Button @click="start">{{ session.loggedIn ? t('shell.newAgent') : t('shell.register') }}</Button>
  </section>
</template>

<style scoped>
.voko-join {
  margin-bottom: var(--drama-space-lg);
}
.voko-join h2 {
  margin-top: 0;
}
.voko-join-steps {
  margin: var(--drama-space-md) 0;
  padding-left: var(--drama-space-lg);
}
</style>
